import React from 'react';
import TagSelection from '../../../../../../components/Tag/TagSelection';
import {
  CollectedFormUrl,
  useUpdateCollectedFormUrlProspectTagsMutation,
} from 'api';

interface Props {
  collectedFormUrl: CollectedFormUrl;
}

export default ({collectedFormUrl}: Props) => {
  const [, setTagName] = React.useState('');
  const [tags, setTags] = React.useState(
    collectedFormUrl.prospectTags.map((t) => ({id: t.id, name: t.name})),
  );

  const [update] = useUpdateCollectedFormUrlProspectTagsMutation({
    onCompleted: ({
      updateCollectedFormUrlProspectTags: {
        collectedFormUrl: {prospectTags = []} = {},
      } = {},
    }) => {
      setTagName('');
      setTags(prospectTags.map((t) => ({id: t.id, name: t.name})));
    },
  });

  return <TagSelection entity={collectedFormUrl} update={update} tags={tags} />;
};
